<script>
import Dfes from '@/components/Dfes.vue'
export default {
  components: {
    Dfes
  }
}
</script>

<template>
  <Dfes
    document="nfces"
    descriptionDocument="NFCe (s)"
  />
</template>

<style>

</style>
